import { INVOICE_STATUS, InvoiceStatusString } from "../../../constants/invoice_status.jsx";

export const InvoiceStatusBadge = ({ value }) => {
  const statusText = InvoiceStatusString[value];

  const getStatusStyle = (status) => {
    switch (status) {
      case INVOICE_STATUS.Invoice_Paid:
        return { backgroundColor: "#55FF00", color: "black" }; // Green
      case INVOICE_STATUS.Invoice_Overdue:
        return { backgroundColor: "#FF0000", color: "black" }; // Red
      case INVOICE_STATUS.Invoice_Pending:
        return { backgroundColor: "#FF9D00", color: "black" }; // Orange
    }
  };
  const style = {
    ...getStatusStyle(value),
    padding: "5px",
    borderRadius: "15px",
    margin: "5px",
    fontWeight: "500",
    paddingLeft: "10px",
    paddingRight: "10px",
    minWidth: "90px",
    textAlign: "center", 
    display: "inline-flex", 
    justifyContent: "center", 
    alignItems: "center", 
  };

  return <span style={style}>{statusText}</span>;
};
